export default __webpack_public_path__ + "static/media/kannada.df499437.png";